import React from 'react';
import styled from 'styled-components';
import { useLocation, useNavigate } from 'react-router-dom';
import { DecodableStory } from '@/common/types/decodable';

const BookPage: React.FC = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const level: number = location.state.level;
  const levelInfo: string = location.state.levelInfo;
  const story: DecodableStory = location.state.story;

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <BookContainer>
      <BackButton onClick={handleBack}>Back to Library</BackButton>
      <BookTitle>{story.title}</BookTitle>
      <BookInfo>
        Level {level} - {levelInfo}
      </BookInfo>
      <BookContent>{story.pages.join('\n')}</BookContent>
    </BookContainer>
  );
};

export default BookPage;

const BookContainer = styled.div`
  font-family: Arial, sans-serif;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
`;

const BookTitle = styled.h1`
  font-size: 2.5rem; // Increased from 2rem
  margin-bottom: 15px; // Increased from 10px
`;

const BookInfo = styled.p`
  font-size: 1.2rem; // Increased from 1rem
  color: #666;
  margin-bottom: 25px; // Increased from 20px
`;

const BookContent = styled.div`
  font-size: 1.4rem; // Increased from 1.1rem
  line-height: 1.8; // Increased from 1.6
  white-space: pre-wrap;
`;

const BackButton = styled.button`
  background-color: #f0f0f0;
  border: none;
  padding: 12px 24px; // Increased from 10px 20px
  font-size: 1.2rem; // Increased from 1rem
  cursor: pointer;
  margin-bottom: 25px; // Increased from 20px
  border-radius: 5px; // Added for a smoother look

  &:hover {
    background-color: #e0e0e0;
  }
`;
